/* Para Al Oum — tiroir « Mon compte » (ouverture à droite, mobile + ordinateur). */
(() => {
  const panel = document.querySelector('[data-account-drawer]');
  const overlay = document.querySelector('[data-account-overlay]');
  if (!panel || !overlay) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lastFocus = null;
  let hideTimer = null;
  const isOpen = () => panel.classList.contains('is-open');
  const focusables = () => [...panel.querySelectorAll('a[href],button:not([disabled]),shopify-account,[tabindex]:not([tabindex="-1"])')].filter((el) => el.getClientRects().length);
  const setExpanded = (v) => document.querySelectorAll('[data-account-open]').forEach((el) => el.setAttribute('aria-expanded', v ? 'true' : 'false'));
  /* Fenêtre de connexion Shopify ouverte au-dessus du tiroir ? (elle gère alors elle-même clavier et focus) */
  const shopifyDialogOpen = () => [...panel.querySelectorAll('shopify-account')].some((el) => el.shadowRoot?.querySelector('dialog[open]'));

  function closeOthers() {
    if (document.querySelector('[data-cart-drawer].open')) document.querySelector('[data-cart-drawer] [data-cart-close]')?.click();
    if (document.querySelector('.mobile-menu-panel.open')) document.querySelector('.mobile-menu-panel [data-menu-close]')?.click();
    if (document.querySelector('[data-wishlist-panel].is-open')) document.querySelector('[data-wishlist-panel] [data-wishlist-close]')?.click();
  }

  /* Repli : si le composant Shopify n'est pas disponible, on affiche le lien vers la page de connexion Shopify. */
  function checkSignin() {
    const signin = panel.querySelector('[data-acc-signin]');
    const fallback = panel.querySelector('[data-acc-fallback]');
    if (!signin || !fallback) return;
    const ok = !!window.customElements?.get('shopify-account') && !!signin.shadowRoot;
    signin.hidden = !ok;
    fallback.hidden = ok;
  }

  function open(trigger) {
    if (isOpen()) return;
    closeOthers();
    lastFocus = trigger || document.activeElement;
    clearTimeout(hideTimer);
    overlay.hidden = false;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    setExpanded(true);
    document.documentElement.classList.add('pao-acc-lock');
    checkSignin();
    void panel.offsetWidth; /* force le rendu avant l'animation */
    panel.classList.add('is-open');
    overlay.classList.add('is-open');
    panel.querySelector('[data-account-close]')?.focus({ preventScroll: true });
  }

  function close(restoreFocus = true) {
    if (!isOpen()) return;
    panel.classList.remove('is-open');
    overlay.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    setExpanded(false);
    document.documentElement.classList.remove('pao-acc-lock');
    const done = () => { if (!isOpen()) { panel.hidden = true; overlay.hidden = true; } };
    if (reduce.matches) done(); else hideTimer = setTimeout(done, 340);
    if (restoreFocus && lastFocus && document.contains(lastFocus) && lastFocus.getClientRects().length) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-account-open]');
    if (trigger) {
      event.preventDefault();
      /* Depuis le menu mobile : le menu se ferme (theme.js), le focus reviendra sur le bouton menu. */
      const fromMenu = trigger.closest('.mobile-menu-panel');
      open(fromMenu ? document.querySelector('.mobile-menu-trigger') : trigger);
      return;
    }
    if (!isOpen()) return;
    if (event.target.closest('[data-account-close]') || event.target === overlay) close();
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen() || shopifyDialogOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) { event.preventDefault(); panel.focus(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('focusin', (event) => {
    if (isOpen() && !shopifyDialogOpen() && !panel.contains(event.target)) panel.querySelector('[data-account-close]')?.focus({ preventScroll: true });
  });

  window.addEventListener('pageshow', (event) => { if (event.persisted) close(false); });
})();
